/**
 * @file     MetaPixelPageViews.tsx
 * @purpose  Reports App Router navigations to the Meta Pixel. The landing view
 *           is skipped only when the boot snippet has already queued it.
 */
'use client';

import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';
import { trackMetaPageView } from '@/services/analytics/metaPixel';

export function MetaPixelPageViews() {
  const pathname = usePathname();
  const first = useRef(true);

  useEffect(() => {
    if (first.current) {
      first.current = false;
      // The boot snippet queues the landing PageView before hydration. If it
      // has not (the stub was not in the document yet), this effect is the
      // first chance to report that view. Claiming the flag here keeps a late
      // snippet from sending a second one.
      if (window.__reltaMetaPageView) return;
      window.__reltaMetaPageView = true;
    }
    trackMetaPageView();
  }, [pathname]);

  return null;
}
